/* eslint-disable react/jsx-wrap-multilines */
/* eslint-disable react/jsx-props-no-spreading */
import React, { useState } from 'react';
import {
  Chip,
  Grid,
  InputAdornment,
  TextField,
  Typography,
  useMediaQuery,
  // Box,
  // Table,
  // TableBody,
  // TableCell,
  // TableHead,
  // TableRow,
} from '@mui/material';
// import { makeStyles } from '@mui/styles';
import { useUpdateEffect } from 'react-use';
import SearchIcon from '@mui/icons-material/Search';
import NewModal from '../NewModal';
import DataTable from '../DataTable';

// const useStyles = makeStyles((theme) => ({
//   innerRow: {
//     '& td': {
//       border: 0,
//       padding: theme.spacing(1),
//     },
//     background: theme.palette.divider,
//   },
// }));

const CalendarGroupSearchModal = ({
  open,
  items: { groupLists },
  onUpdate,
  onCancel,
  hideBackdrop,
}) => {
  const [inputStr, setInputStr] = useState('');
  const [selectRobotList, setSelectRobotList] = useState([]);
  const [filterRobots, setFilterRobots] = useState(groupLists);
  const matches = useMediaQuery('(max-width:600px)');
  // const classes = useStyles();

  const updateButtons = [
    { label: '취소', onClick: onCancel },
    {
      label: '선택 완료',
      disabled: selectRobotList.length === 0,
      onClick: () => onUpdate(selectRobotList),
    },
  ];

  const onChange = (e) => {
    const {
      target: { value },
    } = e;
    setInputStr(value);
  };

  const onAddGroupClick = ({ id }) => {
    const newItems = [...selectRobotList];
    const selected = groupLists.find(({ id: robotId }) => robotId === id);

    if (selected) {
      newItems.push(selected);
      setSelectRobotList(newItems);
      setFilterRobots(filterRobots.filter((item) => !newItems.includes(item)));
    }
  };

  const onDeleteGroupClick = (id) => {
    const newItems = selectRobotList.filter((item) => item.id !== id);
    setSelectRobotList(newItems);
    setFilterRobots(groupLists.filter((item) => !newItems.includes(item)));
  };

  useUpdateEffect(() => {
    if (inputStr !== '' && groupLists.length > 0) {
      const filter = groupLists.filter(
        ({ groupName }) => groupName.indexOf(inputStr.toLowerCase()) > -1,
      );
      setFilterRobots([...filter]);
    }
  }, [inputStr]);

  return (
    <NewModal
      open={open}
      buttons={updateButtons}
      onClose={onCancel}
      hideBackdrop={hideBackdrop}
    >
      <Grid container spacing={1} sx={{ width: matches ? '100%' : '600px' }}>
        <Grid item xs={12}>
          <Typography variant="h5">로봇 그룹 검색 및 선택</Typography>
        </Grid>
        <Grid item xs={12}>
          {selectRobotList &&
            selectRobotList.map(({ id, name }) => (
              <Chip
                key={id}
                label={name}
                color="secondary"
                variant="outlined"
                onDelete={() => onDeleteGroupClick(id)}
                sx={{ mt: 1, ml: 1 }}
              />
            ))}
        </Grid>
        <Grid item xs={12}>
          <TextField
            name="group-text-input"
            placeholder="로봇 그룹으로 검색하세요."
            value={inputStr || ''}
            onChange={onChange}
            margin="dense"
            size="small"
            fullWidth
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
          />
        </Grid>
        <Grid item xs={12}>
          <DataTable
            rows={filterRobots}
            columns={[
              // { field: 'id', headerName: '그룹 ID', width: 140 },
              { field: 'name', headerName: '그룹', width: 140 },
              {
                field: 'robot',
                headerName: '로봇 정보',
                width: 400,
                valueGetter: (params) =>
                  params.row.robot
                    ? params.row.robot.reduce(
                        (acc, { serial, alias }) =>
                          `${acc ? `${acc},` : ''} ${serial}${
                            alias ? `(${alias})` : ''
                          }`,
                        '',
                      )
                    : '-',
              },
            ]}
            pageSize={5}
            rowsPerPageOptions={[5]}
            headerHeight={40}
            rowHeight={25}
            onRowClick={onAddGroupClick}
            height={219}
          />
        </Grid>
        {/* inputStr && (
          <Grid item xs={12}>
            <Box
              sx={{
                overflowY: 'scroll',
                overflowX: 'hidden',
                maxHeight: 300,
                width: '100%',
              }}
            >
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ py: 1 }}>그룹</TableCell>
                    <TableCell sx={{ py: 1 }}>
                      로봇 및 로봇 사용자 정보
                    </TableCell>
                  </TableRow>
                </TableHead>
                {inputStr && filterRobots.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={3}>검색결과가 없습니다.</TableCell>
                  </TableRow>
                ) : (
                  filterRobots.map((group) => (
                    <TableRow
                      key={group.groupId}
                      onClick={() => onAddGroupClick(group)}
                      sx={{ cursor: 'pointer' }}
                    >
                      <TableCell>{group.groupName}</TableCell>
                      <TableCell colSpan={2}>
                        {group.robot.length > 0 && (
                          <Table>
                            <TableBody>
                              {group.robot.map(({ serial, alias, users }) => (
                                <TableRow>
                                  <TableCell
                                    padding="none"
                                    sx={{ borderBottom: 0 }}
                                  >
                                    {serial}
                                  </TableCell>
                                  <TableCell
                                    padding="none"
                                    sx={{ borderBottom: 0 }}
                                  >
                                    {alias}
                                  </TableCell>
                                  <TableCell
                                    padding="none"
                                    sx={{ borderBottom: 0 }}
                                  >
                                    {users && users.length > 0 ? (
                                      <Table>
                                        <TableBody>
                                          {users.map(
                                            ({ name: userName, nickName }) => (
                                              <TableRow
                                                className={classes.innerRow}
                                              >
                                                <TableCell>
                                                  {userName}
                                                </TableCell>
                                                <TableCell>
                                                  {nickName || '-'}
                                                </TableCell>
                                              </TableRow>
                                            ),
                                          )}
                                        </TableBody>
                                      </Table>
                                    ) : (
                                      '사용자 정보 없음'
                                    )}
                                  </TableCell>
                                </TableRow>
                              ))}
                            </TableBody>
                          </Table>
                        )}
                      </TableCell>
                    </TableRow>
                  ))
                )}
              </Table>
            </Box>
          </Grid>
        ) */}
      </Grid>
    </NewModal>
  );
};

export default CalendarGroupSearchModal;
